(function () {
  if (window.fitpackPersonalizareInitialized) return;
  window.fitpackPersonalizareInitialized = true;
  var lastOpener = null;

  // Web3Forms endpoint — the access key is set per-form on the hidden
  // "access_key" input rendered by snippets/personalizeaza-button.liquid.
  var WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';

  function updateDimensionMode(form) {
    if (!form) return;
    var customRow = form.querySelector('[data-personalizare-custom-dim]');
    if (!customRow) return;
    var customRadio = form.querySelector('[data-personalizare-dim-custom]');
    var isCustom = !!(customRadio && customRadio.checked);
    customRow.hidden = !isCustom;
    var customInputs = customRow.querySelectorAll('input[type="number"]');
    for (var i = 0; i < customInputs.length; i++) {
      customInputs[i].required = isCustom;
      if (!isCustom) customInputs[i].value = '';
    }
  }

  function fitTipCutieFont(modal) {
    if (!modal) return;
    var input = modal.querySelector('input[id^="TipCutie-"]');
    if (!input) return;
    // Guard against measuring before the modal has finished layout
    // (clientWidth would read as 0/near-0 and wrongly shrink the font).
    if (input.clientWidth < 50) return;
    var maxSize = 16;
    var minSize = 10;
    var size = maxSize;
    input.style.fontSize = size + 'px';
    while (input.scrollWidth > input.clientWidth && size > minSize) {
      size -= 0.5;
      input.style.fontSize = size + 'px';
    }
  }

  document.addEventListener('change', function (event) {
    var radio = event.target.closest('[data-personalizare-dim-option], [data-personalizare-dim-custom]');
    if (!radio) return;
    updateDimensionMode(radio.closest('form'));
  });

  function selectVariant(modal, opener) {
    var card = opener.closest('.cf-card');
    var productForm = opener.closest('form');
    var variantInput = card ? card.querySelector('[data-cf-variant-input]') : productForm && productForm.querySelector('[name="id"]');
    var explicitVariant = opener.getAttribute('data-personalizare-variant');
    if (explicitVariant) variantInput = { value: explicitVariant };
    if (!variantInput) return;
    var options = modal.querySelectorAll('[data-personalizare-dim-option]');
    for (var i = 0; i < options.length; i++) {
      if (options[i].getAttribute('data-variant-id') === variantInput.value) {
        options[i].checked = true;
        break;
      }
    }
    if (card) {
      var color = card.querySelector('.cf-color-pill.active');
      var colors = modal.querySelectorAll('[name="tip_carton"]');
      for (var j = 0; j < colors.length; j++) {
        colors[j].checked = !!color && colors[j].value === color.textContent.trim();
      }
    }
  }

  function openModal(modal, opener) {
    lastOpener = opener;
    // 2026-09-29: on product pages whose description hides the theme's
    // product info column (#fp-gama pages), the modal is rendered inside a
    // hidden container. Move it to <body> so it is always visible.
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    selectVariant(modal, opener);
    modal.hidden = false;
    document.body.classList.add('personalizare-modal-open');
    updateDimensionMode(modal.querySelector('[data-personalizare-form]'));
    // Wait for the browser to finish laying out the now-visible modal
    // before measuring the input's width, otherwise clientWidth can
    // still reflect the pre-open (hidden) state.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fitTipCutieFont(modal);
      });
    });
    var firstField = modal.querySelector('input:not([type="hidden"]):not([type="checkbox"]), textarea');
    if (firstField) firstField.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.body.classList.remove('personalizare-modal-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastOpener && lastOpener.isConnected) lastOpener.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      var openModalEl = document.querySelector('.personalizare-modal:not([hidden])');
      if (openModalEl) closeModal(openModalEl);
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-personalizare-open]');
    if (opener) {
      var modal = document.getElementById(opener.getAttribute('aria-controls'));
      if (modal) openModal(modal, opener);
      return;
    }

    var closer = event.target.closest('[data-personalizare-close]');
    if (closer) {
      var modalToClose = closer.closest('[data-personalizare-modal]');
      if (modalToClose) closeModal(modalToClose);
    }
  });

  function setStatus(statusEl, message, variant) {
    statusEl.hidden = false;
    statusEl.textContent = message;
    statusEl.classList.remove('personalizare-form__status--success', 'personalizare-form__status--error');
    if (variant) statusEl.classList.add('personalizare-form__status--' + variant);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-personalizare-form]');
    if (!form) return;
    event.preventDefault();

    var statusEl = form.querySelector('[data-personalizare-status]');
    var submitBtn = form.querySelector('[data-personalizare-submit]');
    var accessKeyInput = form.querySelector('input[name="access_key"]');

    if (!accessKeyInput || !accessKeyInput.value || accessKeyInput.value.indexOf('REPLACE_WITH') === 0) {
      setStatus(
        statusEl,
        'Formularul nu este configurat încă (lipsește cheia de acces Web3Forms). Contactați administratorul magazinului.',
        'error'
      );
      return;
    }

    submitBtn.disabled = true;
    statusEl.hidden = true;

    var formData = new FormData(form);

    fetch(WEB3FORMS_ENDPOINT, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        submitBtn.disabled = false;
        if (data && data.success) {
          setStatus(statusEl, 'Cererea a fost trimisă. Vă vom contacta în curând.', 'success');
          form.reset();
        } else {
          setStatus(
            statusEl,
            'A apărut o eroare la trimitere. Încercați din nou sau scrieți-ne la comenzi@fitpack.ro.',
            'error'
          );
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        setStatus(
          statusEl,
          'A apărut o eroare la trimitere. Încercați din nou sau scrieți-ne la comenzi@fitpack.ro.',
          'error'
        );
      });
  });
})();
